import { Borders, Row, Workbook, Worksheet } from "exceljs"
import moment from "moment"
import { approvalChecked } from "utils"
import { DataList } from "../types"

type ExportExcel = {
  data: DataList[]
  dateFilter: string
  companyName?: string
}

export const exportExcel = async ({
  data,
  dateFilter
}: ExportExcel) => {
  const workbook = new Workbook()
  const worksheet = workbook.addWorksheet("Sheet 1")
  const columns = [
    "NO",
    "RECEIVED REJECTED ID#",
    "REF REJECTED ITEM ID#",
    "REF BILL ID#",
    "DATE",
    "TYPE",
    "LOCATION",
    "VENDOR",
    "STATUS APPROVAL",
    "QTY REJECRED",
    "QTY RECEIVED",
    "BACK REJECTED",
    "SUBTOTAL"
  ]
  worksheet.views = [{ showGridLines: false }]

  // Title
  makeTitle(worksheet, dateFilter)

  // Header
  const headers = worksheet.addRow(columns)
  headers.font = { bold: true, color: { argb: 'FFFFFFFF' } }
  headers.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF000000" }
    }
    cell.border = {
      top: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } }
    }
  })

  makeRows(data, worksheet)

  // create xlsx
  await workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `register-received-rejected-${dateFilter}.xlsx`
    a.click()
    URL.revokeObjectURL(url)
  })
}

function makeTitle(worksheet: Worksheet, dateFilter: string) {
  worksheet.mergeCells(1, 1, 1, 13)
  const purchaseCell = worksheet.getCell(1, 1)
  purchaseCell.value = "PURCHASE"
  purchaseCell.font = { bold: true, size: 15 }
  purchaseCell.alignment = {
    vertical: "middle",
    horizontal: "center"
  }

  worksheet.mergeCells(2, 1, 2, 13)
  const registerCell = worksheet.getCell(2, 1)
  registerCell.value = "REGISTER RECEIVED REJECTED"
  registerCell.font = { bold: true, size: 15 }
  registerCell.alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true
  }

  worksheet.mergeCells(3, 1, 3, 13)
  const dateCell = worksheet.getCell(3, 1)
  dateCell.value = `DATE: ${dateFilter}`
  dateCell.font = { bold: true, size: 13 }
  dateCell.alignment = {
    vertical: "middle",
    horizontal: "left",
    wrapText: true
  }

  worksheet.getColumn(2).width = 20
}

function makeRows(data: ExportExcel["data"], worksheet: Worksheet) {
  const convertType = (data: number) => {
    if (data === 1) {
      return "RECEIVED REJECTED ITEM"
    }
    if (data === 2) {
      return "RECEIVED REJECTED MONEY"
    }
    if (data === 3) {
      return "RECEIVED REJECTED ADJUSTMENT"
    }
    return "-"
  }
  let itemRow: Row

  const cellBorder: Partial<Borders> = {
    top: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } },
    bottom: { style: "thin", color: { argb: "000000" } },
    right: { style: "thin", color: { argb: "000000" } }
  }

  data.forEach((item, index) => {
    itemRow = worksheet.addRow([
      index + 1,
      item.trx_code,
      item.ref_rejected_item,
      item.ref_bill_id,
      item.transaction_date ? moment(item.transaction_date).format("DD/MM/YYYY") : "-",
      item.type_received ? convertType(item.type_received) : "-",
      item.location_name,
      item.vendor_name,
      item?.approve_status ? approvalChecked(item.approve_status) : "-",
      Number(item?.qty_rejected),
      Number(item?.qty_received),
      Number(item?.qty_rejected || 0) - Number(item?.qty_received || 0),
      Number(item?.subtotal)
    ])

    itemRow.eachCell((cell) => {
      cell.border = cellBorder
    })
  })

  const totalBalance = data.reduce((total, item) => total + Number(item?.subtotal)!, 0);

  // summary
  const sumarryPayment = worksheet.addRow(
    Array(11).fill("").concat(["SUMMARY SUBTOTAL", totalBalance])
  )

  sumarryPayment.getCell(12).font = { bold: true }
  sumarryPayment.getCell(13).font = { bold: true }
}
